import React, { useEffect } from "react";

import { lockClick } from "./lock-click";
import type { ToastPrivateProps, ToastProps } from "./PropsTypes";
import { Info, Success, Fail, Pending } from "./icons";
import { ToastContainer } from "./ToastContainer";

const Toast: React.FC<ToastProps & ToastPrivateProps & { visible?: boolean }> = (props) => {
	const onClick = () => {
		props.onClose?.();
	};

	useEffect(() => {
		if (!props.visible) {
			lockClick(false);
			return;
		}
		lockClick(true);
	}, [props.visible]);

	const renderIcon = () => {
		const { type, message } = props;

		if (String(message).length >= 15) {
			return null;
		}

		switch (type) {
			case "success":
				return <Success />;
			case "fail":
				return <Fail />;
			case "pending":
				return <Pending />;
			case "info":
				return <Info />;
			default:
				return null;
		}
	};

	const renderMessage = () => {
		const { message } = props;
		if (message !== undefined && message !== null && message !== "") {
			return <div className="toast__content">{message}</div>;
		}
		return null;
	};

	return (
		<ToastContainer visible={props.visible} onClick={onClick} onClose={props.onClose}>
			{renderIcon()}
			{renderMessage()}
		</ToastContainer>
	);
};

export default Toast;
